import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import QuickPlaySkillCard from "./quick-play-skill-card.js";
import { getFunctionalSkills } from "../../../modules/functional_skills.js";
import { setPageTitle } from "../../../modules/application/pages";
import { withWhiteLabelContext } from "react-whitelabel";

import "./quick-play.css";

class QuickPlay extends Component {
  constructor(props) {
    super(props);

    this.state = {
      functionalSkills: [],
      startingFunctionalSkillSession: false,
    };

    this.props.dispatch(setPageTitle(this.props.label.quickPlayScreen.pageTitle));
  }

  functionalSkillSessionChosed() {
    this.setState({
      startingFunctionalSkillSession: true,
    });
  }

  async componentDidMount() {
    let token = localStorage.getItem("timocco.auth");
    let functionalSkillsResult = await getFunctionalSkills(token);

    if (
      functionalSkillsResult &&
      functionalSkillsResult.data &&
      functionalSkillsResult.data.success
    ) {
      this.setState({
        functionalSkills: functionalSkillsResult.data.functional_skills,
      });
    }
  }

  printQuickPlaySkillCards() {
    let token = localStorage.getItem("timocco.auth");
    let { functionalSkills, startingFunctionalSkillSession } = this.state;
    let data = functionalSkills;
    return data.map((item, index) => (
      <QuickPlaySkillCard
        key={index}
        name={item.name}
        description={item.description}
        icon_path={item.icon_path}
        functional_skill_id={item.id}
        token={token}
        can_start={!startingFunctionalSkillSession}
        start_functional_skill={this.functionalSkillSessionChosed.bind(this)}
      ></QuickPlaySkillCard>
    ));
  }

  render() {
      const { label } = this.props;
    return (
      <div className="quick_play_container">
        <div className="quick_play_description">
          {label.quickPlayScreen.heading}
        </div>
        {this.printQuickPlaySkillCards()}
      </div>
    );
  }
}

const withState = connect((state) => {
  const {
    player,
    player_game_session,
    player_game_session_activity,
    result,
    skill,
    user,
  } = state;

  return {
    players: player.players,
    owned_players: player.owned_players,
    retrieved_assigned_players: player.retrieved_assigned_players,
    retrieved_players: player.retrieved_players,
    assigned_players: player.assigned_players,
    skills: skill.skills,
    results: result.results,
    token: user.token,
    currentUser: user,
    currentUserId: user.currentUserId,
    currentUserFirstName: user.currentUserFirstName,
    playerGameSessions: player_game_session.player_game_sessions,
    playerGameSessionActivities:
      player_game_session_activity.player_game_session_activities,
  };
});

export default withWhiteLabelContext(withRouter(withState(QuickPlay)));



// WEBPACK FOOTER //
// ./src/components/containers/quick-play/quick-play.js